var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "refooter"
  }, [_c('a', {
    staticClass: "bg1",
    attrs: {
      "href": "https://www.facebook.com/streamliveme/"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "bg2",
    attrs: {
      "href": "https://twitter.com/streamliveme"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "bg3",
    attrs: {
      "href": "https://www.instagram.com/streamliveme/"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "bg4",
    attrs: {
      "href": "https://www.youtube.com/channel/UCkjies8Dg7XAw_x62Y2FYCA"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_c('span', [_vm._v("Copyright©" + _vm._s(_vm.crtime) + " " + _vm._s(_vm.brand))])]), _vm._v(" "), _c('p', {
    staticClass: "info info2"
  }, [_vm._t("links", function () {
    return [_c('a', {
      attrs: {
        "href": "/protocol/sample_2257.html",
        "target": "_blank"
      }
    }, [_vm._v("18 U.S.C. 2257 Exemption Statement")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "/protocol/terms.html",
        "target": "_blank"
      }
    }, [_vm._v("Terms of Service")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "/protocol/privacy.html",
        "target": "_blank"
      }
    }, [_vm._v("Privacy Policy")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "/protocol/refund.html",
        "target": "_blank"
      }
    }, [_vm._v("Refund Policy")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "/protocol/privacy_notice.html",
        "target": "_blank"
      }
    }, [_vm._v("Privacy Notice")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "/protocol/cookie.html",
        "target": "_blank"
      }
    }, [_vm._v("Cookie Policy")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "/protocol/user_choice.html",
        "target": "_blank"
      }
    }, [_vm._v("User's Choice")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "/protocol/intellectual.html",
        "target": "_blank"
      }
    }, [_vm._v("INTELLECTUAL PROPERTY RIGHTS")])];
  })], 2), _vm._v(" "), _c('img', {
    staticClass: "qianhai",
    attrs: {
      "src": "/app/spa/images/qianhai1.png"
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };